import { Box, Button, Checkbox, styled } from '@mui/material'

export const ModalImageArea = styled(Box)(() => ({
  margin: '24px',
  display: 'grid',
  gridTemplateColumns: 'repeat(6, 94.67px)',
  columnGap: '8px',
  rowGap: '8px',
}))

export const ImageWrap = styled(Box)(() => ({
  position: 'relative',
}))

export const DeleteCheckbox = styled(Checkbox)(() => ({
  position: 'absolute',
  right: '5.12px',
  top: '4.73px',
  border: '1px solid #AAAAAA',
  background: '#FFF',
  borderRadius: '2px',
  padding: '0',
  '&.Mui-checked': {
    color: '#FF661A',
  },
}))

export const Paging = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}))

export const PrevButton = styled(Button)(() => ({
  background: 'white',
  padding: '0',
}))
export const NextButton = styled(Button)(() => ({
  background: 'white',
  padding: '0',
}))
